"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.oldLivaNovaColors = exports.oldEpsyColors = exports.livaNovaColors = exports.epsyColors = void 0;
var commonColors = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ blue: "#0092FF", blue20: "#CCE9FF", blue5: "#F2FAFF" }, { indigo: "#251C75", indigo20: "#D3D2E3", indigo5: "#F4F4F8" }), { magenta: "#B0008E", magenta5: "#F9F0F6" }), { marine: "#4D07FB", marine20: "#DBCDFE", marine5: "#F6F3FF" }), { orange: "#E87613", orange20: "#FAE4D0", orange5: "#FEF8F3" }), { pink120: "#AD0369", pink: "#F20493" }), { purple120: "#2E016D", purple: "#400198" }), { sky: "#3DC0F6", sky20: "#D8F2FD", sky5: "#F5FCFF" }), { teal: "#00ADBC", teal20: "#CCEFF2", teal5: "#F2FBFC" }), { violet120: "#623188", violet: "#AD0CFF" }), { violet20: "#EFCEFF", violet5: "#FBF3FF" }), { yellow: "#FFDB3A", yellow20: "#FDF5D5", yellow5: "#FEFDF5" });
exports.epsyColors = __assign(__assign(__assign(__assign(__assign(__assign({}, commonColors), { 
    // PRIMARY
    primary: "#400198", primaryPressed: "#2E016D" }), { success: "#04C57F", success20: "#CDF3E5" }), { error: "#DA265C", error20: "#FFD5D8" }), { warning: "#F5A623", warning20: "#FFF8E2" }), { 
    // NEUTRALS
    white: "#FFFFFF", grey1: "#222222", grey2: "#606060", grey3: "#777777", grey4: "#A3A3A3", grey5: "#E8E8E8", grey6: "#F2F2F2", grey7: "#FAFBFD" });
exports.livaNovaColors = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, commonColors), { 
    // PRIMARY
    primary: "#5779F0", primaryPressed: "#344990" }), { violet120: "#623188", violet: "#A452E3" }), { violet20: "#DFC2F5", violet5: "#F9F3FD" }), { success: "#04C57F", success20: "#CDF3E5" }), { error: "#E13535", error20: "#FFD5D8" }), { warning: "#F5A623", warning20: "#FFF8E2" }), { 
    // NEUTRALS
    white: "#FFFFFF", grey1: "#23273A", grey2: "#656DA8", grey3: "#7F87B7", grey4: "#C6CAE1", grey5: "#ECECFC", grey6: "#F4F6FE", grey7: "#FAFBFF" });
var oldEpsyColorTokens = {
    primary: {
        purple: "#400198",
        pink: "#f20493"
    },
    secondary: {
        indigo: "#251c75",
        marine: "#4d07fb",
        violet: "#AD0CFF",
        teal: "#00ADBC",
        blue: "#0092ff",
        sky: "#3dc0f6",
        orange: "#E87613"
    },
    shade: {
        1: "rgba(0,0,0,0.85)",
        2: "#606060",
        3: "#A3A3A3",
        4: "#E8E8E8",
        5: "#F2F2F2",
        6: "#FAFBFD",
        7: "#5779F0",
        8: "#C6CAE1",
        9: "#ECE6F5",
        10: "",
        11: "#777777",
        white: "#FFF"
    },
    traffic: {
        alertRed: "#DA265C",
        green: "#04C57F"
    }
};
exports.oldEpsyColors = __assign(__assign({}, oldEpsyColorTokens), { callToAction: {
        upload: oldEpsyColorTokens.primary.pink,
        uploadHover: oldEpsyColorTokens.secondary.indigo
    }, button: {
        submit: oldEpsyColorTokens.primary.purple,
        submitHover: oldEpsyColorTokens.secondary.indigo,
        delete: oldEpsyColorTokens.primary.pink,
        copied: oldEpsyColorTokens.primary.pink,
        copyHover: oldEpsyColorTokens.secondary.indigo,
        notCopied: oldEpsyColorTokens.primary.purple,
        add: oldEpsyColorTokens.secondary.indigo
    }, text: {
        suggestLink: oldEpsyColorTokens.primary.purple,
        title: oldEpsyColorTokens.primary.purple
    }, overviewCard: {
        bannerBackground: oldEpsyColorTokens.primary.pink
    }, inviteCode: {
        charBoxBoarder: oldEpsyColorTokens.shade[4],
        charBoxBoarderCopied: oldEpsyColorTokens.primary.pink,
        text: oldEpsyColorTokens.primary.pink
    }, lozenge: {
        backgroundColor: "#777777",
        textColor: "#222222"
    }, table: {
        rowBackgroundColor: oldEpsyColorTokens.shade[9]
    } });
var oldLivaNovaColorTokens = {
    primary: {
        purple: "#5779F0",
        pink: "#f20493"
    },
    secondary: {
        indigo: "#B0008E",
        marine: "#4d07fb",
        violet: "#AD0CFF",
        teal: "#00ADBC",
        blue: "#0092ff",
        sky: "#3dc0f6",
        orange: "#E87613"
    },
    shade: {
        1: "rgba(0,0,0,0.85)",
        2: "#606060",
        3: "#A3A3A3",
        4: "#E8E8E8",
        5: "#F2F2F2",
        6: "#FAFBFD",
        7: "#222222",
        8: "#ECECFC",
        9: "#656DA8",
        10: "#F9F3FD",
        11: "#7f87b7",
        white: "#FFF"
    },
    traffic: {
        alertRed: "#DA265C",
        green: "#04C57F"
    }
};
exports.oldLivaNovaColors = __assign(__assign({}, oldLivaNovaColorTokens), { callToAction: {
        upload: oldLivaNovaColorTokens.primary.purple,
        uploadHover: oldLivaNovaColorTokens.secondary.indigo
    }, button: {
        submit: oldLivaNovaColorTokens.primary.purple,
        submitHover: oldLivaNovaColorTokens.secondary.indigo,
        delete: oldLivaNovaColorTokens.secondary.indigo,
        copied: oldLivaNovaColorTokens.secondary.indigo,
        copyHover: oldLivaNovaColorTokens.secondary.indigo,
        notCopied: oldLivaNovaColorTokens.primary.purple,
        add: oldLivaNovaColorTokens.primary.purple
    }, text: {
        suggestLink: oldLivaNovaColorTokens.primary.purple,
        title: oldLivaNovaColorTokens.shade[7]
    }, overviewCard: {
        bannerBackground: oldLivaNovaColorTokens.secondary.indigo
    }, inviteCode: {
        charBoxBoarder: oldLivaNovaColorTokens.shade[4],
        charBoxBoarderCopied: oldLivaNovaColorTokens.secondary.indigo,
        text: oldLivaNovaColorTokens.secondary.indigo
    }, lozenge: {
        backgroundColor: oldLivaNovaColorTokens.shade[8],
        textColor: oldLivaNovaColorTokens.shade[9]
    }, table: {
        rowBackgroundColor: oldLivaNovaColorTokens.shade[10]
    } });
